import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { images } from '../data/images';

const Technologies = () => {
  const { t } = useLanguage();

  return (
    <section id="technologies" className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t.technologies.title}
          </h2>
        </div>

        <div className="space-y-16">
          {/* E2 Technologies */}
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div className="relative">
              <img
                src={images.technologies.iotNetwork1}
                alt="E2 Technologies"
                className="rounded-2xl shadow-2xl w-full"
              />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">{t.technologies.e2.title}</h3>
              <p className="text-lg text-gray-600 mb-6">{t.technologies.e2.description}</p>
              <ul className="space-y-3 mb-6">
                {t.technologies.e2.features.map((feature, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <CheckCircle className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" />
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
              <Button className="bg-blue-900 hover:bg-blue-800 text-white">
                {t.technologies.e2.cta}
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </div>
          </div>

          {/* Viziosense AI */}
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div className="order-2 lg:order-1">
              <h3 className="text-3xl font-bold text-gray-900 mb-4">{t.technologies.viziosense.title}</h3>
              <p className="text-lg text-gray-600 mb-6">{t.technologies.viziosense.description}</p>
              <ul className="space-y-3 mb-6">
                {t.technologies.viziosense.features.map((feature, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <CheckCircle className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" />
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
              <Button className="bg-teal-600 hover:bg-teal-700 text-white">
                {t.technologies.viziosense.cta}
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </div>
            <div className="relative order-1 lg:order-2">
              <img
                src={images.technologies.computerVision}
                alt="Viziosense AI"
                className="rounded-2xl shadow-2xl w-full"
              />
            </div>
          </div>

          {/* RFID & Access Control */}
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div className="relative">
              <img
                src={images.technologies.rfid}
                alt="RFID Access Control"
                className="rounded-2xl shadow-2xl w-full"
              />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">{t.technologies.rfid.title}</h3>
              <p className="text-lg text-gray-600 mb-6">{t.technologies.rfid.description}</p>
              <ul className="space-y-3 mb-6">
                {t.technologies.rfid.features.map((feature, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <CheckCircle className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" />
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
              <Button className="bg-blue-900 hover:bg-blue-800 text-white">
                {t.technologies.rfid.cta}
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Technologies;